export function isVariantInStock({
  quantity = 0,
  inReserveQuantity = 0,
  inProductionQuantity = 0
}) {
  return quantity + inProductionQuantity - inReserveQuantity > 0;
}